var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('inline-svg',{attrs:{"src":_vm.theme.logo.src},on:{"loaded":_vm.handleLogoLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }